import { Component, OnInit, ChangeDetectorRef, EventEmitter, Input, Output } from '@angular/core';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { Subscription } from 'rxjs';

interface Topic {
    name: string;
    id: number;
    isOrganisationalLabel: boolean;
    isArticleCountToZero: boolean;
    keyConcept: Array<KeyConcept>;
    subtopics: Array<Topic>;
    sources: Array<any>;
    sourceParams: SourceParams;
    sourcesSubTopic: SourcesSubTopic;
    exportDocumentRules: any;
    parentSearchContextList: Array<number>;
    parentRelContextList: Array<number>;
    globalRelevance: boolean;
    processNonArticles: boolean;
    skipRelevance: boolean;
    suppressSummary: boolean;
    suppressMDS?: boolean;
    ignoreProcess?: boolean;
    dor?: any;
    intentScore?: any;
    level: number;
    showAddIcon: boolean;
    ParentList: Array<number>;
    ParentValueChanged: boolean;
    isTemplate: boolean;
}
interface KeyConcept {
    name: string;
    isSearch: boolean;
    isRelevance: boolean;
}

interface SourceParams {
    [key: string]: any;
}

interface SourcesSubTopic {
    repoIds: { [key: string]: any };
    repoAvailable: boolean;
    knowledgeStoreIds: { [key: string]: any };
    includeSubTopic: { [key: string]: boolean };
    webAvailable: boolean;
    favouriteWebsites: Array<string>;
    dispreferredWebsites: Array<string>;
}

@Component({
    selector: 'app-sub-topic-sources',
    templateUrl: './sub-topic-sources.component.html',
    styleUrls: ['./sub-topic-sources.component.scss'],
})
export class SubTopicSourcesComponent implements OnInit {
    //@Output() sourcesDataEvent = new EventEmitter<any>(); // Declare an EventEmitter to emit data
    // subTopics: Array<Topic> = [];
    // sourceParams: SourceParams = {};
    @Output() saveSubTopicSources = new EventEmitter<Topic>();
    @Input() topic!: Topic;
    @Input() modal!: NgbActiveModal;
    @Input() gksLevel: string = 'gyanLevel';
    isMobile = false;
    faAngleUp = faAngleUp;
    faAngleDown = faAngleDown;
    google = false; //Changed it from true to false
    webURL: any;
    IgnorewebURL: any; // Array that should be Ignored
    webURLArray: any; // Array that should be prioritised
    ignorewebURLArray: any; // Final Array that should be Ignored
    selectedWebURLArray: any; //Final Array that should be prioritised
    selectedIgnoreWebURLArray: any;
    specialSourceUrls: any;
    prioritizeDomains: any;
    deprioritizeDomains: any;
    disableSubmit = true;
    checkedList: any;
    checkedRepoIds: Array<string> = [];
    value: number = 50;
    googleChecked = true;
    specialSourcesList: any;
    sourceKeys: any;
    form: FormGroup;
    isSpecialSourcesButtonDisabled: boolean = false;
    transformedData: any = {
        knowledgeStoreIds: {},
        repoIds: {},
    };

    constructor(
        private toastr: ToastrService,
        private cd: ChangeDetectorRef,
        private submitgyanService: SubmitgyanService,
        private fb: FormBuilder,
        private commonServiceService: CommonServiceService,
    ) {
        this.checkWidth();
        this.checkedList = [];
        this.webURLArray = [];
        this.specialSourceUrls = [];
        this.ignorewebURLArray = [];
        this.selectedWebURLArray = [];
        this.selectedIgnoreWebURLArray = [];
        this.prioritizeDomains = [];
        this.deprioritizeDomains = [];
        //this.sourceParams = {};

        this.form = this.fb.group({
            fields: this.fb.array([]),
        });
    }
    ngOnInit(): void {
        this.getSpecialsources();
    }

    populateFromLocalStorage() {
        const specialSourceuls = Object.keys(this.topic.sourceParams);
        this.webURLArray = this.topic.sourcesSubTopic.favouriteWebsites.filter((url: string) => !specialSourceuls.includes(url)) || [];

        const specialSourceUrls = Object.keys(this.topic.sourceParams);
        console.log('specialSourceUrls', specialSourceUrls);
        specialSourceUrls.forEach((key: string, index: number) => {
            const paramData = this.topic.sourceParams[key] || {};
            console.log('paramData', paramData['includeSubTopic']);
            //const includeSubTopic = paramData['includeSubTopic'] ? paramData['includeSubTopic'][0] : false;
            const includeSubTopic = paramData['includeSubTopic']
                ? typeof paramData['includeSubTopic'][0] === 'string'
                    ? paramData['includeSubTopic'][0].toLowerCase() === 'true'
                    : Boolean(paramData['includeSubTopic'][0])
                : false;

            console.log('includeSubTopic', typeof includeSubTopic, includeSubTopic);

            // if(typeof includeSubTopic === "string"){
            //     if (includeSubTopic.toLowerCase() === "true") {
            //         return true;
            //     } else if (includeSubTopic.toLowerCase() === "false") {
            //         return false;
            //     }
            // }
            const firstParameter = Object.keys(paramData).find((param) => param !== 'includeSubTopic');

            if (firstParameter) {
                const valuesArray = paramData[firstParameter] || [];
                // Added a form group for each parameter and its corresponding values
                const formGroup = this.fb.group({
                    key: [key],
                    parameter: [firstParameter],
                    values: [valuesArray ? valuesArray[0] : ''],
                    includeSubTopic: [includeSubTopic],
                });
                this.fields.push(formGroup);

                // Disabled the key dropdown and parameter text input after selection
                this.fields.at(index).get('key')?.disable();
                this.fields.at(index).get('parameter')?.disable();
            }
        });

        if (specialSourceUrls.length === this.sourceKeys.length) {
            this.isSpecialSourcesButtonDisabled = true;
        }
    }

    get fields(): FormArray {
        return this.form.get('fields') as FormArray;
    }

    isKeyDisabled(key: string) {
        // Get all selected keys from the form except the current row
        const selectedKeys = this.fields.controls.map((control) => control.get('key')?.value).filter((selectedKey) => selectedKey !== null && selectedKey !== '');

        // Return true if this key is already selected in any other row
        return selectedKeys.includes(key);
    }

    onKeyChange(index: number) {
        const selectedKey = this.fields.at(index).get('key')?.value;
        const availableKeys = this.sourceKeys.filter((key: string) => !this.fields.controls.some((control) => control.get('key')?.value === key));
        // Retrieve values from the specialSourcesList based on the selected key
        if (selectedKey && this.specialSourcesList[selectedKey]) {
            const parameters = this.specialSourcesList[selectedKey];
            if (parameters && parameters.length > 0) {
                this.fields.at(index).get('parameter')?.setValue(parameters[0]);
            } else {
                this.fields.at(index).get('parameter')?.setValue('');
            }

            // Disable the key dropdown and parameter text input after selection
            this.fields.at(index).get('key')?.disable();
            this.fields.at(index).get('parameter')?.disable();
        }
        if (availableKeys.length === 0) {
            this.isSpecialSourcesButtonDisabled = true; // Disable the button when all keys are selected
        } else {
            this.isSpecialSourcesButtonDisabled = false;
        }
    }

    AddSpecialSources() {
        this.isSpecialSourcesButtonDisabled = true;
        // Check if all source keys are already selected
        const selectedKeys = this.fields.controls.map((control) => control.get('key')?.value);
        console.log(selectedKeys);
        const availableKeys = this.sourceKeys.filter((key: string) => !selectedKeys.includes(key));

        // If there are still available keys, add a new FormGroup to the FormArray
        if (availableKeys.length > 0) {
            const fieldGroup = this.fb.group({
                key: new FormControl('', Validators.required), // Dropdown for source keys
                parameter: new FormControl(''), // Input for parameters
                values: new FormControl(''), // Input for values
                includeSubTopic: new FormControl(''), // Input for values: new FormControl(''), // Input for values
            });

            this.fields.push(fieldGroup);
        }

        // After adding, check if this was the last available key
        if (availableKeys.length === 1) {
            this.isSpecialSourcesButtonDisabled = true; // Disable section as no keys are left
        }
    }

    deleteSpecialSource(index: number) {
        this.fields.removeAt(index);

        if (this.sourceKeys.length > 0) {
            this.isSpecialSourcesButtonDisabled = false;
        }
    }

    checkSpecialSourcesButtonState() {
        const selectedKeys = this.fields.controls.map((control) => control.get('key')?.value);
        const availableKeys = this.sourceKeys.filter((key: string) => !selectedKeys.includes(key));
        this.isSpecialSourcesButtonDisabled = availableKeys.length === 0;
    }

    getSpecialsources() {
        console.log('getSpecialsources called');
        this.submitgyanService.getSpecialsources().subscribe((response) => {
            this.specialSourcesList = response;
            this.sourceKeys = Object.keys(response);
            console.log(this.sourceKeys);
            this.populateFromLocalStorage();
        });
    }

    checkWidth() {
        const width = window.innerWidth;
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }
    checkurls() {
        return this.webURLArray.length > 0 || this.ignorewebURLArray.length > 0;
    }

    selectedWeb(webURL: string, event: any) {
        this.selectedWebURLArray = this.webURLArray;
        if (event.target.checked) {
            this.googleChecked = true;
            if (!this.selectedWebURLArray.includes(webURL)) {
                this.selectedWebURLArray.push(webURL);
                if (!this.webURLArray.includes(webURL)) {
                    this.webURLArray.push(webURL);
                }
            } else {
                this.toastr.warning('URL already exists in the list');
            }
            this.setTheSliderValue();
        } else {
            this.googleChecked = false;
            const index = this.selectedWebURLArray.findIndex((x: any) => x === webURL);
            if (index !== -1) this.selectedWebURLArray.splice(index, 1);
            this.setTheSliderValue();
        }
        const obj = {
            prioritizeDomains: [...new Set([...this.selectedWebURLArray, ...this.webURLArray])],
        };

        this.prioritizeDomains = obj.prioritizeDomains;
        this.checksubmitGyanButtonValidation();
    }

    editIgnoreWebURL(editURL: any) {
        this.IgnorewebURL = editURL;
        // this.checkEmptyIgnoreUrl();
        if (!this.isURLValid(this.IgnorewebURL)) {
            this.toastr.error('Please add valid Website URL');
        } else {
            const index = this.ignorewebURLArray.indexOf(editURL);
            this.ignorewebURLArray.splice(index, 1);
        }
        this.checksubmitGyanButtonValidation();
    }

    removeIgnoreWebURL(removeItem: any) {
        const index = this.ignorewebURLArray.indexOf(removeItem);
        this.ignorewebURLArray.splice(index, 1); // Removes one element, starting from index
        const obj = {
            deprioritizeDomains: [...new Set([...this.selectedIgnoreWebURLArray, ...this.ignorewebURLArray])],
        };
        this.deprioritizeDomains = obj.deprioritizeDomains;
        this.setTheSliderValue();
        this.checksubmitGyanButtonValidation();
    }

    checksubmitGyanButtonValidation() {
        //console.log('the validations', this.selectedWebURLArray, this.selectedIgnoreWebURLArray, this.checkedList, this.checkedRepoIds);
        if (this.selectedWebURLArray.length > 0 || this.selectedIgnoreWebURLArray.length > 0 || this.checkedList.length > 0 || this.checkedRepoIds.length > 0) {
            //|| this.checkedList.length > 0 || this.checkedRepoIds.length > 0
            this.disableSubmit = true;
        } else {
            this.disableSubmit = false;
        }
    }

    setTheSliderValue() {
        if (this.checkedList.length > 0 && (this.selectedWebURLArray.length > 0 || this.checkurls())) this.value = 50;
        else this.value = 25;
        //this.value = 25;
    }
    addWebURLArray() {
        if (!this.isURLValid(this.webURL)) {
            this.toastr.error('Please add valid Website URL');
        } else {
            if (!this.webURLArray.includes(this.webURL)) {
                this.webURLArray.push(this.webURL);
                if (!this.selectedWebURLArray.includes(this.webURL)) {
                    this.selectedWebURLArray.push(this.webURL);
                    this.cd.detectChanges();
                } else {
                }
                this.cd.detectChanges();
                console.log('the selected url is pushed', this.webURLArray);
            } else {
                console.log('the selected url is already exists', this.webURLArray);
                this.toastr.warning('URL already exists in the list');
            }
            this.webURL = null;
        }
        console.log('the selected urls to display', this.webURLArray);
        this.checksubmitGyanButtonValidation();
        // this.checkEmptyUrl();

        const obj = {
            prioritizeDomains: [...new Set([...this.selectedWebURLArray, ...this.webURLArray])],
        };
        this.prioritizeDomains = obj.prioritizeDomains;
        this.setTheSliderValue();
    }

    IgnoreWebURLArray() {
        if (this.webURLArray.includes(this.IgnorewebURL)) {
            this.toastr.warning('already exists in the preferred website list');
        } else {
            if (!this.isURLValid(this.IgnorewebURL)) {
                this.toastr.error('Please add valid Website URL');
            } else {
                if (!this.ignorewebURLArray.includes(this.IgnorewebURL)) {
                    this.ignorewebURLArray.push(this.IgnorewebURL);
                } else {
                    this.toastr.warning('URL already exists in the list');
                }
                this.IgnorewebURL = null;
            }
        }
        // this.checkEmptyIgnoreUrl();
        this.checksubmitGyanButtonValidation();

        const obj = {
            deprioritizeDomains: [...new Set([...this.selectedIgnoreWebURLArray, ...this.ignorewebURLArray])],
        };
        this.deprioritizeDomains = obj.deprioritizeDomains;
        this.setTheSliderValue();
    }

    isURLValid(url: string): boolean {
        try {
            const parsedURL = new URL(url);
            return parsedURL.protocol === 'http:' || parsedURL.protocol === 'https:';
        } catch (error) {
            return false;
        }
    }

    editWebURL(editURL: any) {
        if (editURL == 'https://www.google.com') {
            console.log("can't edit google");
        } else {
            this.webURL = editURL;
            // this.checkEmptyUrl();
            if (!this.isURLValid(this.webURL)) {
                this.toastr.error('Please add valid Website URL');
            } else {
                if (this.webURLArray.includes(this.webURL)) {
                    const index = this.webURLArray.indexOf(editURL);
                    this.webURLArray.splice(index, 1);
                }
                if (this.selectedWebURLArray.includes(this.webURL)) {
                    const index = this.selectedWebURLArray.indexOf(editURL);
                    this.selectedWebURLArray.splice(index, 1);
                }
            }
        }
        this.checksubmitGyanButtonValidation();
    }

    removeWebURL(removeItem: any) {
        if (removeItem == 'https://www.google.com') {
            this.google = false;
        }
        if (this.selectedWebURLArray.includes(removeItem)) {
            const indexinSelected = this.selectedWebURLArray.indexOf(removeItem);
            this.selectedWebURLArray.splice(indexinSelected, 1);
        }
        if (this.webURLArray.includes(removeItem)) {
            const index = this.webURLArray.indexOf(removeItem);
            this.webURLArray.splice(index, 1); // Removes one element, starting from index
        }

        const obj = {
            prioritizeDomains: [...new Set([...this.selectedWebURLArray, ...this.webURLArray])],
        };
        this.prioritizeDomains = obj.prioritizeDomains;
        this.setTheSliderValue();
        this.checksubmitGyanButtonValidation();
    }

    findTopicById(topic: any, id: number): any | null {
        if (topic.id === id) {
            return topic;
        }
        if (topic.subtopics && topic.subtopics.length > 0) {
            for (const subtopic of topic.subtopics) {
                const found = this.findTopicById(subtopic, id);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }

    saveWebUrlsFormToLocalStorage() {
        // Retrieve the item from localStorage
        const storedData = localStorage.getItem('topicOutline');

        // Parse the JSON data if it exists, or use the default object if it doesn't
        const topicoutline = storedData
            ? JSON.parse(storedData)
            : {
                  name: null,
                  id: null,
                  isOrganisationalLabel: false,
                  isArticleCountToZero: false,
                  keyConcept: [],
                  subtopics: [],
                  sources: [],
                  sourceParams: {},
                  sourcesSubTopic: {
                      repoIds: {},
                      repoAvailable: true,
                      knowledgeStoreIds: {},
                      includeSubTopic: {},
                      webAvailable: false,
                      favouriteWebsites: [],
                      dispreferredWebsites: [],
                  },
                  exportDocumentRules: null,
                  parentSearchContextList: [],
                  parentRelContextList: [],
                  globalRelevance: true,
                  processNonArticles: false,
                  skipRelevance: false,
                  suppressSummary: false,
                  suppressMDS: false,
                  ignoreProcess: false,
                  dor: null,
                  intentScore: null,
                  level: 0,
                  showAddIcon: false,
                  ParentList: [],
                  ParentValueChanged: false,
                  isTemplate: false,
              };

        // Initialize empty arrays to store current valid sources and sourceParams
        const currentSourceParams: any = {};
        const currentFavouriteWebsites: Array<string> = [];

        // Add special sources to sources and sourceParams
        this.fields.controls.map((control: AbstractControl) => {
            const formGroup = control as FormGroup;
            const key = formGroup.get('key')?.value || '';
            const parameter = formGroup.get('parameter')?.value;
            const values = formGroup.get('values')?.value; // Retrieve the values for the parameter
            const includeSubTopic = formGroup.get('includeSubTopic')?.value || false;

            if (key && parameter && values) {
                // Structure the current sourceParams correctly
                if (!currentSourceParams[key]) {
                    currentSourceParams[key] = {};
                }
                currentSourceParams[key]['includeSubTopic'] = [includeSubTopic];
                currentSourceParams[key][parameter] = [values];

                // Add the key to the favouriteWebsites array (to handle special sources in the same array)
                currentFavouriteWebsites.push(key);
            }
        });

        const combinedFavouriteWebsites = [...this.webURLArray, ...currentFavouriteWebsites];

        topicoutline.sourcesSubTopic.favouriteWebsites = [...new Set(combinedFavouriteWebsites)];

        // Update topicoutline with the new sourceParams (removes any deleted sources)
        topicoutline.sourceParams = currentSourceParams;

        const subtopicSourcesGK_key = localStorage.getItem('subtopicSource_gyanKnowledgeStore');
        const subtopicSourcesMK_key = localStorage.getItem('subtopicSource_myKnowledgeStore');
        // Parse the JSON data if it exists, or use the default object if it doesn't
        const subtopicSourcesGK = subtopicSourcesGK_key ? JSON.parse(subtopicSourcesGK_key) : {};
        const subtopicSourcesMK = subtopicSourcesMK_key ? JSON.parse(subtopicSourcesMK_key) : {};
        const transformsubtopicSourcesGK = this.TrnasformsubtopicSourcesGK(subtopicSourcesGK);
        const transformsubtopicSourcesMK = this.TrnasformsubtopicSourcesMK(subtopicSourcesMK);
        const knowledgeStoreIds = transformsubtopicSourcesGK.knowledgeStoreIds;
        const repoIds = transformsubtopicSourcesMK.repoIds;

        const currentTopic = this.findTopicById(topicoutline, this.topic.id);
        topicoutline.sourcesSubTopic.includeSubTopic = currentTopic.sourcesSubTopic.includeSubTopic;
        topicoutline.sourcesSubTopic.knowledgeStoreIds =
            Object.keys(knowledgeStoreIds).length === 0
                ? currentTopic.sourcesSubTopic.knowledgeStoreIds
                : { ...currentTopic.sourcesSubTopic.knowledgeStoreIds, ...knowledgeStoreIds };

        topicoutline.sourcesSubTopic.repoIds = Object.keys(repoIds).length === 0 ? currentTopic.sourcesSubTopic.repoIds : { ...currentTopic.sourcesSubTopic.repoIds, ...repoIds };
        // Save the updated topicoutline back to localStorage
        localStorage.setItem('topicOutline', JSON.stringify(topicoutline));
        this.topic.sourceParams = topicoutline.sourceParams;
        this.topic.sourcesSubTopic.favouriteWebsites = topicoutline.sourcesSubTopic.favouriteWebsites;
        this.topic.sourcesSubTopic.knowledgeStoreIds = topicoutline.sourcesSubTopic.knowledgeStoreIds;
        this.topic.sourcesSubTopic.repoIds = topicoutline.sourcesSubTopic.repoIds;
        this.topic.sourcesSubTopic.includeSubTopic = topicoutline.sourcesSubTopic.includeSubTopic;
        this.saveSubTopicSources.emit(this.topic);
        this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
    }
    TrnasformsubtopicSourcesGK(subtopicSourcesGK: any) {
        // const transformedData: any = {
        //     knowledgeStoreIds: {},
        // };
        for (const uuid in subtopicSourcesGK[this.topic.id]) {
            if (subtopicSourcesGK[this.topic.id].hasOwnProperty(uuid)) {
                const gksIds = uuid;
                const formData = subtopicSourcesGK[this.topic.id][uuid].formData;
                formData.fields.forEach((field: any) => {
                    const fieldKey = field.id == '' ? field.key : field.id;
                    const dataType = field.dataType;
                    let values: any = [];

                    // text splitting string into an array
                    if (dataType === 'Text' || dataType === 'text') {
                        const rawValues = field.tagValues || '';
                        values = typeof rawValues === 'string' ? rawValues.split(',').map((value: string) => value.trim()) : rawValues;
                    }
                    // Date type by storing dateFieldFrom and dateFieldTo as an array
                    if (dataType === 'Date' || dataType === 'date' || dataType === 'datetime') {
                        values = [this.convertToISO(new Date(field.dateFieldFrom)), this.convertToISO(new Date(field.dateFieldTo))];
                    }

                    // initiate the entry for knowledgeStoreIds if it doesn't exist
                    console.log('field', field);
                    if (typeof fieldKey == 'string' && values && values.length > 0 && values.some((value: any) => value)) {
                        const targetIds = field.id !== '' ? 'repoIds' : 'knowledgeStoreIds';
                        if (!this.transformedData[targetIds][gksIds]) {
                            this.transformedData[targetIds][gksIds] = {};
                        }

                        if (!this.transformedData[targetIds][gksIds][fieldKey]) {
                            this.transformedData[targetIds][gksIds][fieldKey] = {
                                DT: dataType,
                                V: [],
                            };
                        }

                        // merge and avoid duplicates
                        this.transformedData[targetIds][gksIds][fieldKey].V = [...new Set([...this.transformedData[targetIds][gksIds][fieldKey].V, ...values])];
                    }
                });
            }
        }
        return this.transformedData;
    }

    // Method to convert date to ISO format
    convertToISO(date: Date): string {
        return date.toISOString();
    }
    TrnasformsubtopicSourcesMK(subtopicSourcesMK: any) {
        // const transformedData: any = { repoIds: {} };
        for (const uuid in subtopicSourcesMK[this.topic.id]) {
            if (subtopicSourcesMK[this.topic.id].hasOwnProperty(uuid)) {
                const mksIds = uuid;
                const formData = subtopicSourcesMK[this.topic.id][uuid].formData;
                formData.fields.forEach((field: any) => {
                    const fieldKey = field.id;
                    const dataType = field.dataType;
                    let values: any = [];

                    // text splitting string into an array
                    if (dataType === 'text') {
                        const rawValues = field.value || ''; // The values stored in the form (string or array)
                        values = typeof rawValues === 'string' ? rawValues.split(',').map((value: string) => value.trim()) : rawValues;
                    }

                    // Date type by storing dateFieldFrom and dateFieldTo as an array
                    if (dataType === 'date') {
                        values = [this.convertToISO(new Date(field.dateFieldFrom)), this.convertToISO(new Date(field.dateFieldTo))]; // Store the date range in an array
                    }

                    // initiate the entry for repoIds if it doesn't exist
                    if (values && values.length > 0 && values.some((value: any) => value)) {
                        if (!this.transformedData.repoIds[mksIds]) {
                            this.transformedData.repoIds[mksIds] = {};
                        }

                        if (!this.transformedData.repoIds[mksIds][fieldKey]) {
                            this.transformedData.repoIds[mksIds][fieldKey] = {
                                DT: dataType,
                                V: [],
                            };
                        }

                        // merge and avoid duplicates
                        this.transformedData.repoIds[mksIds][fieldKey].V = [...new Set([...this.transformedData.repoIds[mksIds][fieldKey].V, ...values])];
                    }
                });
            }
        }
        return this.transformedData;
    }
    closeModal() {
        this.modal.dismiss('Cross click');
    }
}
